export function init() {

    //console.log("tracking init");

    if ("paul-mann.com.au".indexOf(window.location) > -1) {
        return;
    }

    jQuery(document).bind("gform_confirmation_loaded", function (e, formid) {

        var enquirynature = "";//jQuery("#input_4_7 option:selected").val();
        var productName = "";//jQuery("#input_4_8").val();
        var eventName = "";
        var data = {};

        if (formid == base.PRODUCT_ENQUIRY_FORM_ID) {
            //general product enquiry

            data = {
                event: "generate_lead",
                eventLabel: "Product Enquiry",
                eventName: "Product Enquiry",
                eventCategory: "Product Enquiry",
                eventAction: "Product Enquiry",
                enquiryNature: enquirynature,
                productName: productName
            }
        }

        if (formid == base.REVIEW_FORM_ID) {

            //product review form
            data = {
                event: "generate_lead",
                eventName: "Product Review",
                eventLabel: "Product Review",
                eventCategory: "Product Review",
                eventAction: "Product Review",
                productName: productName
            }
        }

        if (formid == base.CONTACT_FORM_ID) {
            // contact form
            data = {
                event: "generate_lead",
                eventLabel: "Contact Form",
                eventName: "Contact Form",
                eventCategory: "Contact Form",
                eventAction: "Contact Form"
            }
        }

        if (formid == base.NEWSLETTER_FORM_ID) {
            // newsletter signup form
            data = {
                event: "generate_lead",
                eventLabel: "Newsletter Signup",
                eventName: "Newsletter Signup",
                eventCategory: "Newsletter Signup",
                eventAction: "Newsletter Signup"
            }
        }

        if (formid == 8) {
            //  stock enquiry form
            data = {
                event: "generate_lead",
                eventLabel: "Stock Enquiry",
                eventName: "Stock Enquiry",
                eventCategory: "Stock Enquiry",
                eventAction: "Stock Enquiry",
                productName: productName
            }
        }

        if (formid == base.CHAT_FORM_ID) {
            //  chat window
            data = {
                event: "generate_lead",
                eventLabel: "Chat Window",
                eventName: "Chat Window",
                eventCategory: "Chat Window",
                eventAction: "Chat Window",
                productName: productName
            }
        }

        pushtodatalayer(data);
        //sendemailalert({ data: data, e: e });
    });

}

export function pushtodatalayer(data) {

    // console.log(window.location.href);
    // console.log("2021.com.au".indexOf(window.location.hrefation))
    // console.log(window.location.href.indexOf("creatordigital.com.au"))
    if (window.location.href.indexOf("2021.com.au") > -1 || window.location.href.indexOf("creatordigital.com.au") > -1) {
        return;
    }

    console.log("push to datalayer: ", data);

    window.dataLayer = window.dataLayer || []; // get or set the dataLayer
    dataLayer.push(data);

}